/**
 * Bloomyer Event — Countdown timer
 * Custom element: <be-event>
 */

if (!customElements.get('be-event')) {
  class BeEvent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.targetDate = null;
    }

    connectedCallback() {
      const dateStr = this.dataset.targetDate;
      if (!dateStr) return;

      this.targetDate = new Date(dateStr).getTime();
      if (isNaN(this.targetDate)) return;

      this.daysEl = this.querySelector('[data-cd-days]');
      this.hoursEl = this.querySelector('[data-cd-hours]');
      this.minutesEl = this.querySelector('[data-cd-minutes]');

      this.update();
      this.timer = setInterval(() => this.update(), 60000); // update every minute
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    update() {
      const now = Date.now();
      const diff = this.targetDate - now;

      if (diff <= 0) {
        if (this.daysEl) this.daysEl.textContent = '0';
        if (this.hoursEl) this.hoursEl.textContent = '0';
        if (this.minutesEl) this.minutesEl.textContent = '0';
        if (this.timer) clearInterval(this.timer);

        const countdown = this.querySelector('.be-countdown');
        if (countdown) countdown.classList.add('be-countdown--expired');
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (this.daysEl) this.daysEl.textContent = days;
      if (this.hoursEl) this.hoursEl.textContent = hours;
      if (this.minutesEl) this.minutesEl.textContent = minutes;
    }
  }

  customElements.define('be-event', BeEvent);
}
